import { motion } from "framer-motion";
import { STATS, FOUNDER } from "../../data/homeContent";
import { HeroVideo } from "./HeroVideo";
import { SignatureReveal } from "./SignatureReveal";

export const FounderVision = () => {
  return (
    <section id="founder" data-testid="founder-vision" className="relative py-24 md:py-32 overflow-hidden">
      <div className="line-weave" />
      <div className="aurora-weave slow" />
      <div className="absolute -top-20 left-0 w-[45rem] h-[45rem] radial-glow blur-3xl pointer-events-none" />

      <div className="relative z-10 max-w-7xl mx-auto px-5 md:px-8 grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
        <motion.div initial={{ opacity: 0, x: -30 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ duration: 0.8 }}
          className="relative">
          <div className="absolute -inset-5 radial-glow blur-2xl pointer-events-none" />
          <HeroVideo />
        </motion.div>

        <div>
          <motion.p initial={{ opacity: 0, y: 16 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
            className="text-sm tracking-[0.24em] uppercase text-[#E7CC86]/80 mb-4">{FOUNDER.eyebrow}</motion.p>
          <SignatureReveal />
          <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }} transition={{ delay: 0.12 }}
            className="font-serif italic text-lg text-[#E7CC86] mb-7">{FOUNDER.roles}</motion.p>

          {FOUNDER.body.map((p, i) => (
            <motion.p key={i} initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }} transition={{ delay: 0.2 + i * 0.1 }}
              className="text-lg text-cream/70 leading-relaxed mb-5 max-w-xl">{p}</motion.p>
          ))}

          <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: 0.4 }}
            className="mt-9 grid grid-cols-2 sm:grid-cols-4 gap-6 pt-8 border-t border-[#C9A24B]/15">
            {STATS.map((s) => (
              <div key={s.label} data-testid="founder-stat">
                <div className="font-display font-bold text-3xl md:text-4xl text-gold">{s.value}</div>
                <p className="mt-1.5 text-xs text-cream/55 leading-snug">{s.label}</p>
              </div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
};
